module.exports = __webpack_public_path__ + "fonts/d85e4310339264b58f21bfcac7130bcc.woff";